<template>
    <svg
        :class="twMerge('w-8 h-8', `fill-primary-500`, className)"
        :viewBox="svgViewBox ?? '0 0 255 255'"
        v-html="svgContent"
        xmlns="http://www.w3.org/2000/svg"
    ></svg>
</template>

<script lang="ts" setup>
import svgs from "~/assets/svg/coffee-assets";
import { twMerge } from "tailwind-merge";
import type { ISvgList } from "~/libs/types/general";

const props = defineProps({
    className: {
        type: String,
        default: "", //fill-amazon-500
    },
    name: {
        type: String as PropType<ISvgList>,
        required: true,
    },
});

const svgContent = computed(() => svgs[props.name]?.value.replaceAll("{{class}}", props.className));
const svgViewBox = computed(() => svgs[props.name]?.viewBox);
</script>

<style></style>
